module.exports = __webpack_public_path__ + "img/s2.163e0d17.png";